import { IPagedFilter } from "./interfaces/IPagedFIlter";

export class InscriptionFilterDTO implements IPagedFilter {
  categories: number[];
  top: number;
  skip: number;
}
